import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getExperienceOfferById } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetExperienceOffer(offerId?: string, enabled = true) {
  const brand = useSelector((state: App.State) => state.tenant.brand);

  return useQuery({
    queryKey: experiencesQueryKeys.offerDetail(offerId ?? '', brand),
    queryFn: ({ signal }) =>
      getExperienceOfferById({
        id: offerId!,
        brand: brand.toLowerCase(),
        curationData: true,
        signal,
      }).then((response) => response.result),
    enabled: enabled && !!offerId && !!brand,
  });
}
